import React from 'react';
import { Heading1, Paragraph, Heading3 } from '../components/typography';
import { Image } from '../components/Image';
import { Container, Row, Col } from '../components/grid';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Oekologiprocent">
    <Container white>
      <Row>
        <Col xs={12} sm={6}>
          <Heading1>Økologiprocent</Heading1>
          <Paragraph>Som en ekstra service tilbyder vi, at udregne økologiprocenten af de drikkevarer vi har leveret til dig.</Paragraph>
          <Heading3 margin="15px 0">Hvad er økologiprocent?</Heading3>
          <Paragraph>Økologiprocenten er en udregning af, hvor stor en procentdel af ens råvareindkøb, målt i kroner, kilo eller liter, der udgøres af økologiske råvarer.
          </Paragraph>
          <Heading3 margin="15px 0">Vores udregning</Heading3>
          <Paragraph>Såfremt du ønsker det, foretager vi en udregning af økologiprocenten af de drikkevarer vi har leveret til din virksomhed. Udregningen udarbejdes for den periode du ønsker og fremsendes pr. email. Vores udregning er gjort op i liter.</Paragraph>
        </Col>
        <Col xs={12} sm={6} textCenter>
          <Image name="oel-vand.oekologiprocent-udregning.png" alt="Udregning af økologiprocent" />
          <Paragraph fontSize="12px">Eksempel på udregning af økologiprocenten</Paragraph>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Image name="oel-vand.oekologiprocent.jpg" alt="Økologiprocent - Det økologiske spisemærke" />
          <Paragraph fontSize="12px"><i>Det økologiske spisemærke</i></Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
